import { Component, OnInit, Input} from '@angular/core';
import { HeaderComponent } from 'app/header/header.component';
import { UserAccount } from 'app/services/userAccount.service';
import { AppHeaderComponent } from 'app/header/appHeader/appHeader.component';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'contrib-login',
  templateUrl: './contribLogin.component.html',
  styleUrls: ['./contribLogin.component.scss', '../contrib.component.scss'],
  providers: [HeaderComponent, AppHeaderComponent],
})
export class ContribLoginComponent implements OnInit {
  @Input() isMobile;
  @Input() owner;
  @Input() projectInfo;
  @Input() isguest;
  guest;
  data;
  modalOpen: boolean;
  storyCover: SafeUrl;
  canEdit: boolean;
  change: boolean;
  required: boolean;
  noPhotoModal: boolean;
  signUp: boolean;
  projectId;

  constructor(
    public userAccount: UserAccount
    ) {}

  ngOnInit() {}

}
